import { isNumber } from '@luna/utils';

const DEFAULT_STACK_MESSAGE_MAX_LENGTH = 40;

export class ScriptErrorDetail {
    constructor(
        public readonly name: string | undefined,
        public readonly message: string | undefined,
        public readonly stack: string | undefined,
        public readonly stackMessageMaxLength?: number,
    ) {
        this.name = name || 'UNKNOWN_ERROR_NAME';
        this.message = message || 'UNKNOWN_MESSAGE';
        this.stackMessageMaxLength = isNumber(stackMessageMaxLength)
            ? stackMessageMaxLength
            : DEFAULT_STACK_MESSAGE_MAX_LENGTH;
        this.stack = this.setStack(stack);
    }

    private setStack(stack = '') {
        return stack.substring(0, this.stackMessageMaxLength);
    }
}
